<template>
    <TimePointSelector v-model="year" :min="min" :max="max" :step="step" :years="years"
        :aria-label="props.option.label" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { TimePointSelector } from 'gertrud';
import { TimePointRequestOptionsItem } from 'atlas-shared/dist/RequestOptions';

const props = withDefaults(defineProps<{
    option: TimePointRequestOptionsItem;
    modelValue?: any;
}>(), {
    modelValue: undefined,
});

const emit = defineEmits<{
    'update:modelValue': [value: number];
}>();

const min = computed(() => props.option.min ?? 1900)
const max = computed(() => props.option.max ?? 2025)
const step = computed(() => props.option.step ?? 1)
const years = computed(() => props.option.years ?? [])

const year = computed({
    get: () => props.modelValue ?? min.value,
    set: (val) => emit('update:modelValue', val),
});
</script>